import { render, staticRenderFns } from "./SkeletonComment.vue?vue&type=template&id=f224eaa8&"
import script from "./SkeletonComment.vue?vue&type=script&lang=js&"
export * from "./SkeletonComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports